/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CalendarStrictHttpResponse } from '../../calendar-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AvailibilityRequestModel } from '../../models/availibility-request-model';
import { UrnAvailabilityDayModelAvailibilityModel } from '../../models/urn-availability-day-model-availibility-model';

export interface DiaryAvailibilityPost$Params {
      body?: AvailibilityRequestModel
}

export function diaryAvailibilityPost(http: HttpClient, rootUrl: string, params?: DiaryAvailibilityPost$Params, context?: HttpContext): Observable<CalendarStrictHttpResponse<UrnAvailabilityDayModelAvailibilityModel>> {
  const rb = new RequestBuilder(rootUrl, diaryAvailibilityPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CalendarStrictHttpResponse<UrnAvailabilityDayModelAvailibilityModel>;
    })
  );
}

diaryAvailibilityPost.PATH = '/Diary/Availibility';
